/* global Fw, actionPath, tinyMCE */
(function() {
    /* jshint validthis: true */
    'use strict';

	function init() {
        //INIT STOP
        if (!document.querySelector(".com-document-library")) return;
        
        $('.com-document-library-item-edit .edit-access').on('click', openActionPopup);
        $('html').on('click', closeAllActionPopups);
        $('.com-document-library-item-access-popup .access-group').on('click', changeViewAccess);
        $('.com-document-library-item-edit-metadata-popup .save-btn').on('click', editMetadata);
        
    }
    
    function openActionPopup(e) {
        e.stopPropagation();
        const btn = e.currentTarget;
        const popup = $(btn).parent().find('.action-popup');
        
        if (popup.hasClass('open')) {
            popup.removeClass('open');
        } else {
            $('.action-popup.open').removeClass('open');
            popup.addClass('open');
        }
    }
    
    function closeActionPopup(e) {
        $(e.currentTarget).closest('.action-popup').removeClass('open');
    }
    
    function closeAllActionPopups(e) {
        if (!e || !$(e.target).closest('.action-ctn')[0]) {
            $('.action-popup.open').removeClass('open');
        }
    }
    
    function changeViewAccess(e) {
        const el = e.currentTarget;
        const ctn = $(el).closest('.action-ctn');
        if (ctn.data('field6') === el.dataset.value) {
            return false;
        }
        
        ctn.data('field6', el.dataset.value)
            .attr('data-field6', el.dataset.value);
        
        saveGenData(ctn, () => {
            $(el).closest('.action-ctn').find('.edit-access .text')
                .text(el.dataset.label ? el.dataset.label : el.textContent);
        });
        
        closeAllActionPopups();
    }
    
    function editMetadata(e) {
        const btn = $(e.currentTarget);
        const popup = btn.closest('.popup');
        const ctn = btn.closest('.action-ctn');
        const title = popup.find('.input[name=field5]').val();
        const description = popup.find('.input[name=field7]').val();
        
        ctn.data('field5', title)
            .attr('data-field5', title)
            .data('field7', description)
            .attr('data-field7', description);
        
        saveGenData(ctn, () => {
            const el = ctn.closest('.com-document-library-item');
            el.find('.com-document-library-item-link')
                .attr('title', description)
                .children('span')
                .text(title);
            // Description element exists in version 2
            el.find('.com-document-library-item-description')
                .text(description);
        });
        
        popup.find('.close-popup-btn').trigger('click');
    }
    
    function saveGenData(ctn, callback) {
        let param = 'ajax=true';
        let dataset = ctn.data();
        
        for (var key in dataset) {
            param += '&' + key + '=' + encodeURIComponent(dataset[key]);
        }
        
        console.log(param);
        ajax(actionPath + 'manageGenData?' + param, (resp) => {
            if (resp.indexOf('success-') > -1) {
                console.log(resp);
                let id = resp.substr(8);
                ctn.data('id', id)
                    .attr('data-id', id);
                
                if (typeof callback === 'function') {
                    callback();
                }
            }
        }, true, null, true);
    }

    $(window).ready(init);

})();
